import React from 'react'
import './Header.css'


function Header() {
  return (
    <div className='HeaderContainer'>
        <div className='ContainText'>
            <h1>zomato</h1>
            <p>Find the best restaurants, cafes and bars in india</p>
        </div>
    </div>
  )
}

export default Header